import { Component, OnInit } from '@angular/core';
import { User } from 'app/core/models/user';
import { FormGroup, FormControl } from '@angular/forms';
import { ConfigurationService } from 'app/core/services/configuration.service';
import { UserService } from 'app/core/services/user.service';
import { Subscription } from 'rxjs';
import { AuthenticatedRouteGuard } from 'security/authenticatedRouteGuard.service';
import { KeycloakService } from 'security/keycloak.service';
import { MerchantService } from 'app/core/services/merchant.service';
import { SupplierService } from 'app/core/services/supplier.service';
import { Merchant } from 'app/core/models/merchant';
import { Supplier } from 'app/core/models/supplier';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-search-user',
  templateUrl: './search-user.component.html',
  styleUrls: ['./search-user.component.css']
})
export class SearchUserComponent implements OnInit {

  ALL = "ALL";

  userFilter: User = new User();
  roles: Array<string> = [];
  merchantSub: Subscription;
  supplierSub: Subscription;
  searchSub: Subscription;
  criteria: {
    search?: string;
    merchantId?: number;
    supplierId?: number;
    roleName?: string;
  };

  userForm = new FormGroup({
    search: new FormControl(""),
    role: new FormControl(),
    merchants: new FormControl(),
    suppliers: new FormControl(),
  })

  allMerchants: Array<Merchant>;
  allSuppliers: Array<Supplier>;

  isMerchantRead: boolean = false;
  isSupplierRead: boolean = false;

  constructor(
    private configService: ConfigurationService,
    private userService: UserService,
    private roleGuard: AuthenticatedRouteGuard,
    private keycloakService: KeycloakService,
    private translateService: TranslateService,
    private merchantService: MerchantService,
    private supplierService: SupplierService,
  ) { }

  ngOnInit() {
    this.getAllRoles();
    this.searchSub = this.userService.notifySubject.subscribe(() => {
      this.search();
    })
    this.keycloakService.rolesObservable.subscribe(roles => {
      if (roles.length !== 0) {
        if (this.roleGuard.isEnabled('MERCHANT_READ')) {
          this.getAllMerchants();
        }
        if (this.roleGuard.isEnabled('SUPPLIER_READ')) {
          this.getAllSuppliers();
        }
      }
    });

  }

  ngOnDestroy(): void {
    if (this.searchSub) {
      this.searchSub.unsubscribe();
    }
    if (this.merchantSub) {
      this.merchantSub.unsubscribe();
    }
    if (this.supplierSub) {
      this.supplierSub.unsubscribe();
    }
  }

  getAllMerchants() {
    this.merchantSub = this.merchantService.getAllMerchants().subscribe(merchants => {
      this.allMerchants = merchants.content;
      this.isMerchantRead = true;
    });
  }

  getAllSuppliers() {
    this.supplierSub = this.supplierService.getAllSuppliers().subscribe(suppliers => {
      this.allSuppliers = suppliers.content;
      this.isSupplierRead = true;
    });
  }

  getAllRoles() {
    this.keycloakService.rolesObservable.subscribe(roles => {
      if (roles.length !== 0) {
        this.roles = [];
        if (this.roleGuard.isEnabled('ADMIN_WORLDLINE')) {
          this.roles = this.configService.config.security.keycloak.roles;
        } else {
          if (this.roleGuard.isEnabled('ADMIN_MERCHANT_PETROL')) {
            this.roles.push("ADMIN_MERCHANT_PETROL", "VIEWER_MERCHANT_PETROL");
          } 
          if (this.roleGuard.isEnabled('ADMIN_MERCHANT_OPH')) {
            this.roles.push("ADMIN_MERCHANT_OPH", "VIEWER_MERCHANT_OPH");
          } 
          if (this.roleGuard.isEnabled('ADMIN_SUPPLIER')) {
            this.roles.push("ADMIN_SUPPLIER", "VIEWER_SUPPLIER");
          }
        }
        if (this.roles[0] !== this.ALL) {
          this.roles.unshift(this.ALL);
        }
      }
    });
  }

  search() {
    this.criteria = {
      search: this.userForm.get("search").value
    };
    if (this.userForm.get("role").value != this.ALL) {
      this.criteria["roleName"] = this.userForm.get("role").value;
    }
    if (this.userForm.get("merchants").value != "") {
      this.criteria["merchantId"] = this.userForm.get("merchants").value;
    }
    if (this.userForm.get("suppliers").value != "") {
      this.criteria["supplierId"] = this.userForm.get("suppliers").value;
    }
    this.userService.emitCriteria(this.criteria);
  }

  transSearchFn = (term: string, item: any) => {
    term = term.toLocaleLowerCase();
    return this.translateService.instant(item).toLocaleLowerCase().indexOf(term) > -1;
  }

  resetForm() {
    this.userForm.reset();
    this.search();
  }
}
